(function(){"use strict";(function(n,d){try{const e="style-npm-crefo-autosuggest-company";if(typeof document<"u"&&document.getElementById(e)===null&&typeof n=="string"&&n.length){const t=document.createElement("style");t.id=e,t.type="text/css",t.appendChild(document.createTextNode(n)),document.head.appendChild(t)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})(".gap-2[data-v-45096cf6]{gap:2rem}.pt-2[data-v-45096cf6]{padding-top:2rem}.pb-4[data-v-45096cf6]{padding-bottom:4rem}.not-found[data-v-45096cf6]{border:1px solid #009ee2;border-top:none}")})();
import { toRefs as we, ref as R, computed as G, openBlock as V, createElementBlock as P, normalizeClass as se, createVNode as ye, unref as h, withCtx as J, renderSlot as D, createTextVNode as le, toDisplayString as U, Transition as je, createCommentVNode as re, useAttrs as Te, nextTick as xe, watch as ke, onBeforeMount as _e, onMounted as De, onUnmounted as Pe, createElementVNode as Q, mergeProps as Ee, toHandlers as qe, Fragment as ve, renderList as be, createBlock as Se, resolveDynamicComponent as Fe, createSlots as ze, onBeforeUpdate as Re, useSlots as Qe, pushScopeId as $e, popScopeId as Ne, defineComponent as Ze, resolveComponent as Ue, createStaticVNode as We, withModifiers as Ge } from "vue";
(function() {
  (function(e, t) {
    try {
      const n = "style-npm-crefo-autosuggest-input";
      if (typeof document < "u" && document.getElementById(n) === null && typeof e == "string" && e.length) {
        const a = document.createElement("style");
        a.id = n, a.type = "text/css", a.appendChild(document.createTextNode(e)), document.head.appendChild(a);
      }
    } catch (n) {
      console.error("vite-plugin-css-injected-by-js", n);
    }
  })(".input-wrapper--crefo-autosuggest[data-v-02787b8b]{position:relative;display:block;border-color:#b5b5b5!important}.input-wrapper--crefo-autosuggest--open[data-v-02787b8b]{border-top-color:#009ee2!important;border-left-color:#009ee2!important;border-right-color:#009ee2!important;border-bottom-color:#0000001a!important}.input-wrapper--crefo-autosuggest--focus[data-v-02787b8b]{border-top-color:#009ee2!important;border-left-color:#009ee2!important;border-right-color:#009ee2!important;border-bottom-color:#009ee2!important}.input-wrapper--crefo-autosuggest>div[data-v-02787b8b]{position:relative;width:100%;display:block}.input-wrapper--crefo-autosuggest>div.loader-wrapper[data-v-02787b8b]{position:absolute;top:10px;right:10px;width:2.2em;height:2.2em;display:inline-block;text-align:center;transition:opacity .3s ease-in-out .15s;-webkit-font-smoothing:antialiased}.input-wrapper--crefo-autosuggest>div.loader-wrapper.fade-enter-active[data-v-02787b8b]{opacity:1}.input-wrapper--crefo-autosuggest>div.loader-wrapper.fade-leave-active[data-v-02787b8b]{opacity:0}.input-wrapper--crefo-autosuggest>div.loader-wrapper .lds-ring[data-v-02787b8b]{display:inline-block;position:relative;width:2em;height:2em}.input-wrapper--crefo-autosuggest>div.loader-wrapper .lds-ring div[data-v-02787b8b]{box-sizing:border-box;display:block;position:absolute;width:2em;height:2em;margin:.2em;border:.2em solid;border-radius:50%;animation:lds-ring-02787b8b 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:#fff transparent transparent transparent}.input-wrapper--crefo-autosuggest>div.loader-wrapper .lds-ring div.border-crefo-blue[data-v-02787b8b]{border-color:#009ee2 transparent transparent transparent}.input-wrapper--crefo-autosuggest>div.loader-wrapper .lds-ring div[data-v-02787b8b]:nth-child(1){animation-delay:-.45s}.input-wrapper--crefo-autosuggest>div.loader-wrapper .lds-ring div[data-v-02787b8b]:nth-child(2){animation-delay:-.3s}.input-wrapper--crefo-autosuggest>div.loader-wrapper .lds-ring div[data-v-02787b8b]:nth-child(3){animation-delay:-.15s}@keyframes lds-ring-02787b8b{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.input-wrapper--crefo-autosuggest>*{height:3.733rem}.input-wrapper--crefo-autosuggest .autosuggest__results-container{position:absolute;display:none;left:-1px;top:57px;width:100%;width:calc(100% + 2px);max-height:405px;overflow-y:auto;z-index:2;border:1px solid #009ee2;border-top:none;text-align:left;background-color:#fff}.input-wrapper--crefo-autosuggest .autosuggest__results-container ul{margin:0;padding:0;width:100%;color:#1e272e;list-style:none}.input-wrapper--crefo-autosuggest .autosuggest__results-container ul li{display:inline-block;margin:0;padding:18px;border-bottom:1px solid rgba(0,0,0,.1);border-radius:0;width:100%;line-height:1.5;align-items:center;cursor:pointer;color:#7f7f7f;background-color:#fff}.input-wrapper--crefo-autosuggest .autosuggest__results-container ul li:last-child{border-bottom:none}.input-wrapper--crefo-autosuggest .autosuggest__results-container ul li.autosuggest__results-item--highlighted{color:#fff;background-color:#009ee2}.input-wrapper--crefo-autosuggest--open .autosuggest__results-container{display:block}");
})();
const Xe = ["aria-labelledby"], Je = ["id"], Ye = ["data-suggestion-index", "data-section-name", "id"], Ke = {
  __name: "DefaultSection",
  props: {
    section: {
      type: Object,
      required: !0
    },
    currentIndex: {
      type: [Number, String],
      required: !1,
      default: 1 / 0
    },
    renderSuggestion: {
      type: Function,
      required: !1
    },
    normalizeItemFunction: {
      type: Function,
      required: !0
    },
    componentAttrPrefix: {
      type: String,
      required: !0
    },
    componentAttrIdAutosuggest: {
      type: String,
      required: !0
    }
  },
  emits: ["updateCurrentIndex", "itemSelected"],
  setup(e, { emit: t }) {
    var n, a, r;
    const s = e, c = Qe(), {
      section: i,
      currentIndex: $,
      renderSuggestion: f,
      normalizeItemFunction: l,
      componentAttrPrefix: u,
      componentAttrIdAutosuggest: x
    } = we(s), v = R($.value), g = (_) => {
      const { name: N, type: y, label: I, liClass: k } = i.value || {};
      return l.value(N, y, I, k, _);
    }, o = (_) => {
      var N;
      return ((N = i.value) == null ? void 0 : N.start_index) + _;
    }, p = (_) => v.value === _ || parseInt(v.value) === _, m = G(() => {
      let { limit: _, data: N } = i.value;
      return N.length < _ && (_ = N.length), N.slice(0, _);
    }), q = (_) => {
      const N = parseInt(_.currentTarget.getAttribute("data-suggestion-index"));
      v.value = N, console.log({ enter: N }), t("updateCurrentIndex", N);
    }, M = () => {
      t("updateCurrentIndex", null);
    }, w = (_) => {
      const N = parseInt(_.currentTarget.getAttribute("data-suggestion-index"));
      v.value = N, t("itemSelected", N);
    }, S = {
      beforeSection: c[`before-section-${(n = i.value) == null ? void 0 : n.name}`],
      afterSectionDefault: c["after-section"],
      afterSectionNamed: c[`after-section-${(a = i.value) == null ? void 0 : a.name}`]
    }, Z = `${u.value}__results-before ${u.value}__results-before--${(r = i.value) == null ? void 0 : r.name}`, B = S.beforeSection && S.beforeSection({
      section: i.value,
      className: Z
    }).filter((_) => _.type !== ve && _.children.length === 0) || [];
    return (_, N) => {
      var y, I, k;
      return V(), P("ul", {
        role: "listbox",
        class: se((y = h(i)) == null ? void 0 : y.ulClass),
        "aria-labelledby": (I = h(i)) != null && I.label ? `${h(x)}-${h(i).label}` : void 0
      }, [
        h(B)[0] ? (V(), P("li", {
          key: 0,
          class: se(Z)
        }, U(h(B)[0]), 1)) : (k = h(i)) != null && k.label ? (V(), P("li", {
          key: 1,
          class: se(Z),
          id: `${h(x)}-${h(i).label}`
        }, U(h(i).label), 9, Je)) : re("", !0),
        (V(!0), P(ve, null, be(m.value, (H, F) => (V(), P("li", Ee({
          key: o(F),
          role: "option",
          "data-suggestion-index": o(F),
          "data-section-name": g(H).name,
          id: `${h(u)}__results-item--${o(F)}`
        }, g(H).liAttributes, {
          class: [
            g(H).liClass,
            {
              [`${h(u)}__results-item--highlighted`]: p(o(F)),
              [`${h(u)}__results-item`]: !0
            }
          ],
          onMouseenter: q,
          onMouseleave: M,
          onMousedown: w
        }), [
          h(f) ? (V(), P(ve, { key: 0 }, [
            le(U(h(f)(g(H))), 1)
          ], 64)) : D(_.$slots, "default", {
            key: 1,
            _key: F,
            suggestion: g(H)
          })
        ], 16, Ye))), 128)),
        h(c)["after-section"] ? D(_.$slots, "after-section", {
          key: 2,
          section: h(i),
          className: `${h(u)}__results-after ${h(u)}__results-after--${h(i).name}`
        }) : re("", !0),
        h(c)[`after-section-${h(i).name}`] ? D(_.$slots, `after-section-${h(i).name}`, {
          key: 3,
          section: h(i),
          className: `${h(u)}__results-after ${h(u)}__results-after--${h(i).name}`
        }) : re("", !0)
      ], 10, Xe);
    };
  }
};
function et(e, t) {
  return !!e.className.match(new RegExp("(\\s|^)" + t + "(\\s|$)"));
}
function tt(e, t) {
  et(e, t) || (e.className += " " + t);
}
function nt(e, t) {
  e.classList && e.classList.remove(t);
}
const at = ["id"], rt = ["aria-expanded", "aria-owns"], ot = ["type", "value", "autocomplete", "aria-activedescendant", "aria-controls"], st = ["id"], lt = ["aria-labelledby"], Ie = -1, it = {
  __name: "Autosuggest",
  props: {
    modelValue: {
      type: String,
      default: null
    },
    /** v-binds to the <input /> tag for fine-grain control */
    inputProps: {
      type: Object,
      required: !0
    },
    /** limits the number of suggestions for all sections */
    limit: {
      type: Number,
      required: !1,
      default: 1 / 0
    },
    suggestions: {
      type: Array,
      required: !0
    },
    renderSuggestion: {
      type: Function,
      required: !1,
      default: null
    },
    getSuggestionValue: {
      type: Function,
      required: !1,
      default: (e) => {
        const t = e.item;
        return typeof t == "object" && t.hasOwnProperty("name") ? t.name : t;
      }
    },
    shouldRenderSuggestions: {
      type: Function,
      required: !1,
      default: (e, t) => e > 0 && !t
    },
    sectionConfigs: {
      type: Object,
      required: !1,
      default: () => ({
        default: {
          onSelected: null
        }
      })
    },
    componentAttrIdAutosuggest: {
      type: String,
      required: !1,
      default: "autosuggest"
    },
    componentAttrClassAutosuggestResultsContainer: {
      type: String,
      required: !1,
      default: null
      // `${componentAttrPrefix}__results-container`
    },
    componentAttrClassAutosuggestResults: {
      type: String,
      required: !1,
      default: null
      // `${componentAttrPrefix}__results`
    },
    componentAttrPrefix: {
      type: String,
      required: !1,
      default: "autosuggest"
    }
  },
  emits: [
    "update:modelValue",
    "item-changed",
    "opened",
    "closed"
  ],
  setup(e, { emit: t }) {
    const n = e, a = R([]), r = (d, C) => (a.value.findIndex((L) => L.key === C) === -1 && a.value.push({ key: C, el: d }), C), s = Te(), c = {
      name: "default",
      type: Ke
    }, {
      modelValue: i,
      suggestions: $,
      componentAttrIdAutosuggest: f,
      componentAttrPrefix: l,
      inputProps: u,
      renderSuggestion: x,
      componentAttrClassAutosuggestResults: v,
      componentAttrClassAutosuggestResultsContainer: g,
      sectionConfigs: o,
      shouldRenderSuggestions: p,
      getSuggestionValue: m
    } = we(n), q = R(n.modelValue), M = R(null), w = R(null), S = R(null), Z = R(!1), B = R(!1), _ = {
      type: "text",
      autocomplete: "off"
    }, N = R(null), y = G(() => ({
      ..._,
      ...u.value,
      ...I.value
    })), I = G(() => ({
      onInput: (d) => {
      },
      /**
       * Wrap native click handler to allow for added behavior
       */
      onClick: () => {
        Z.value = !1, s.click && s.click(S.value), xe(() => {
          b(S.value, w.value);
        });
      },
      onSelected: () => {
        S.value && o.value[S.value.name] && o.value[S.value.name].onSelected ? o.value[S.value.name].onSelected(
          S.value,
          M.value
        ) : o.value.default.onSelected ? o.value.default.onSelected(null, M.value) : s.onSelected && s.onSelected(S.value, w.value), ee(null);
      }
    })), k = G(() => p.value(F.value, Z.value)), H = G(() => {
      let d = 0;
      return $.value.map((C) => {
        if (!C.data)
          return;
        const L = C.name ? C.name : c.name;
        let A, E, j, W, X = null;
        o.value[L] && (A = o.value[L].limit, j = o.value[L].type, E = o.value[L].label, W = o.value[L].ulClass, X = o.value[L].liClass), j = j || c.type, A = A || n.limit, A = A || 1 / 0, A = C.data.length < A ? C.data.length : A, E = E || C.label;
        const ae = {
          name: L,
          label: E,
          type: j,
          limit: A,
          data: C.data,
          start_index: d,
          end_index: d + A - 1,
          ulClass: W,
          liClass: X
        };
        return d += A, ae;
      });
    }), F = G(() => H.value.reduce((d, C) => {
      if (!C)
        return d;
      const { limit: L, data: A } = C;
      return d + (A.length >= L ? L : A.length);
    }, 0)), fe = G(() => g.value || `${l.value}__results-container`), ie = G(() => v.value || `${l.value}__results`);
    ke(i, (d) => {
      q.value = d;
    }), ke(k, (d, C) => {
      d !== C && t(d ? "opened" : "closed");
    });
    const me = (d) => {
      const C = d.target.value;
      t("update:modelValue", C), q.value = C, B.value || (M.value = C, w.value = null);
    }, ue = (d) => "computed_section_" + d, ce = (d) => {
      var C, L;
      let A = !1;
      if (d === null)
        return A;
      for (let E = 0; E < H.value.length; E++)
        if (d >= H.value[E].start_index && d <= H.value[E].end_index) {
          let j = d - H.value[E].start_index;
          const W = H.value[E].name;
          let X = a.value.find((ae) => ae.key == ue(`${W}${E}`)).el || !1;
          if (X)
            return A = Y(
              H.value[E].name,
              H.value[E].type,
              (C = X.section) == null ? void 0 : C.label,
              (L = X.section) == null ? void 0 : L.liClass,
              H.value[E].data[j]
            ), A;
        }
    }, he = (d) => {
      const { keyCode: C } = d;
      if ([
        16,
        // Shift
        9,
        // Tab
        17,
        // ctrl
        18,
        // alt/option
        91,
        // OS Key
        93
        // Right OS Key
      ].indexOf(C) > -1)
        return;
      const L = !k.value;
      if (Z.value = !1, B.value = !1, k.value)
        switch (C) {
          case 40:
          case 38:
            if (d.preventDefault(), C === 38 && w.value === null)
              break;
            const A = C === 40 ? 1 : -1, E = Math.max((parseInt(w.value) || 0) + (L ? 0 : A), Ie);
            O(E, F.value), B.value = !0, F.value > 0 && w.value >= 0 ? (ee(ce(w.value)), B.value = !0) : w.value === Ie && (ee(null), q.value = M.value, d.preventDefault()), xe(() => {
              b(S.value, w.value);
            });
            break;
          case 13:
            d.preventDefault(), F.value > 0 && w.value >= 0 && (ee(ce(w.value), !0), B.value = !0), Z.value = !0, I.value.onSelected(B.value);
            break;
          case 27:
            Z.value = !0, w.value = null, q.value = M.value, t("update:modelValue", M.value), d.preventDefault();
            break;
        }
    }, ee = (d, C = !1) => {
      if (w.value === null || !d)
        S.value = null, t("item-changed", null, null);
      else if (d) {
        S.value = d, t("item-changed", d, w.value);
        const L = m.value(d);
        q.value = L, C && (M.value = L), b(d, w.value);
      }
    }, Y = (d, C, L, A, E) => ({
      name: d,
      type: C,
      label: L,
      liClass: (E == null ? void 0 : E.liClass) || A,
      item: E
    }), b = (d, C, L) => {
      const A = document.querySelector(
        L || `.${ie.value}`
      );
      if (!A)
        return;
      const E = A.querySelector(`#${l.value}__results-item--${C}`);
      if (!E)
        return;
      const j = A.clientHeight, W = A.scrollTop, X = E.clientHeight, ae = E.offsetTop;
      X + ae >= W + j ? A.scrollTop = X + ae - j : ae < W && W > 0 && (A.scrollTop = ae);
    }, z = (d) => {
      O(d, -1, !0);
    }, K = (d, C) => {
      const L = document.querySelector(`.${ie.value}`), A = L && L.clientWidth <= C + 17 && C + 17 <= L.clientWidth + 34;
      return d.target.tagName === "DIV" && L && A || !1;
    }, te = () => {
      Z.value = !0, B.value = !0, ee(ce(w.value), !0), I.value.onSelected(!0);
    }, O = (d, C = -1, L = !1) => {
      let A = d;
      if (!L) {
        const W = w.value === null, X = d >= C;
        (W || X) && (A = 0);
      }
      w.value = A;
      const E = document.querySelector(`#${l.value}__results-item--${w.value}`), j = `${l.value}__results-item--highlighted`;
      document.querySelector(`.${j}`) && nt(document.querySelector(`.${j}`), j), E && tt(E, j);
    };
    _e(() => {
      Z.value = !0;
    });
    const oe = (d) => {
      var C = d.target.getBoundingClientRect ? d.target.getBoundingClientRect() : 0;
      N.value = d.clientX - C.left;
    }, ne = (d) => {
      if (d.target.tagName === "BODY") {
        Z.value = !0, w.value = null;
        return;
      }
      d.target.tagName === "INPUT" || K(d, N.value) || (Z.value = !0);
    };
    return De(() => {
      q.value = i == null ? void 0 : i.value, document.addEventListener("mouseup", ne), document.addEventListener("mousedown", oe);
    }), Pe(() => {
      document.removeEventListener("mouseup", ne), document.removeEventListener("mousedown", oe);
    }), (d, C) => (V(), P("div", { id: h(f) }, [
      D(d.$slots, "before-input"),
      Q("div", {
        role: "combobox",
        "aria-expanded": k.value ? "true" : "false",
        "aria-haspopup": "listbox",
        "aria-owns": `${h(f)}-${h(l)}__results`
      }, [
        Q("input", Ee({
          type: y.value.type,
          value: q.value,
          autocomplete: y.value.autocomplete,
          class: [k.value ? `${h(l)}__input--open` : "", y.value.class]
        }, y.value, {
          "aria-autocomplete": "list",
          "aria-activedescendant": k.value && w.value !== null ? `${h(l)}__results-item--${w.value}` : "",
          "aria-controls": `${h(f)}-${h(l)}__results`,
          onInput: me,
          onKeydown: he
        }, qe(I.value, !0)), null, 16, ot)
      ], 8, rt),
      D(d.$slots, "after-input"),
      Q("div", {
        id: `${h(f)}-${h(l)}__results`,
        class: se(fe.value)
      }, [
        k.value ? (V(), P("div", {
          key: 0,
          class: se(ie.value),
          "aria-labelledby": h(f)
        }, [
          D(d.$slots, "before-suggestions"),
          (V(!0), P(ve, null, be(H.value, (L, A) => (V(), Se(Fe(L.type), {
            ref_for: !0,
            ref: (E) => r(E, ue(`${L.name}${A}`)),
            key: ue(`${L.name}${A}`),
            currentIndex: w.value,
            normalizeItemFunction: Y,
            renderSuggestion: h(x),
            section: L,
            componentAttrPrefix: h(l),
            componentAttrIdAutosuggest: h(f),
            onUpdateCurrentIndex: z,
            onItemSelected: te
          }, ze({
            default: J(({ suggestion: E, _key: j }) => [
              D(d.$slots, "default", {
                suggestion: E,
                index: j
              }, () => [
                le(U(E.item), 1)
              ])
            ]),
            "after-section": J(({ section: E }) => [
              D(d.$slots, "after-section", { section: E })
            ]),
            _: 2
          }, [
            be([`before-section-${L.name || L.label}`], (E) => ({
              name: E,
              fn: J(({ section: j, className: W }) => [
                D(d.$slots, `before-section-${L.name || L.label}`, {
                  section: j,
                  className: W
                })
              ])
            })),
            be([`after-section-${L.name || L.label}`], (E) => ({
              name: E,
              fn: J(({ section: j }) => [
                D(d.$slots, `after-section-${L.name || L.label}`, { section: j })
              ])
            }))
          ]), 1064, ["currentIndex", "renderSuggestion", "section", "componentAttrPrefix", "componentAttrIdAutosuggest"]))), 128)),
          D(d.$slots, "after-suggestions")
        ], 10, lt)) : re("", !0),
        D(d.$slots, "after-suggestions-container")
      ], 10, st)
    ], 8, at));
  }
}, T = {
  Accordion: { init: null, update: null },
  ContentTabs: { init: null, update: null },
  Header: { init: null, update: null },
  Input: { init: null, update: null },
  Modal: { init: null, update: null },
  Select: { init: null, update: null },
  Tooltips: { init: null, update: null }
};
T.Accordion = {
  init: function() {
    var e = this, t = document.querySelectorAll(".crefo-ui-accordion");
    if (t && t.length)
      for (var n = function(r) {
        for (var s = t[r], c = s.querySelectorAll(".opener"), i = 0; i < c.length; i++)
          c[i].getAttribute("data-crefo-ui") !== "true" && (c[i].addEventListener("click", (function($) {
            this.toggleClickedAndCloseOthers(s, $.target.parentElement);
          }).bind(e)), c[i].setAttribute("data-crefo-ui", "true"));
      }, a = 0; a < t.length; a++)
        n(a);
  },
  toggleClickedAndCloseOthers: function(e, t) {
    for (var n = e.querySelectorAll("li"), a = 0; a < n.length; a++)
      n[a] !== t && n[a].classList.remove("active");
    t.classList.toggle("active");
  }
};
T.Accordion.init();
T.Header = {
  loginMenuOpen: !1,
  mainSubMenuOpen: !1,
  backdropOpen: !1,
  fixedClass: "scrollspy-fixed",
  activeClass: "backdrop-active",
  init: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    document.querySelector(".header-nav") && (this.initServiceMenuSubmenu(), document.querySelector(".header-secondary") ? (this.initScrollHeader(), this.initHeaderMainMenu(), this.initHeaderLoginMenu(), this.setContentMarginTop(121), document.querySelector(e) && this.initMobileMenu()) : (this.initMinHeader(), document.querySelector(e) && this.initMobileMenu())), document.body.addEventListener("click", (function t(n) {
      n.target.classList.contains(this.activeClass) && (this.closeBackdropAndSubmenues(!0), document.body.removeEventListener("click", t));
    }).bind(this));
  },
  initScrollHeader: function() {
    var e = 0, t = !1, n = document.querySelector(".header-nav"), a = n.classList.contains("scrollspy");
    a && n.getAttribute("data-crefo-ui") !== "true" && (window.addEventListener("scroll", (function() {
      e = window.pageYOffset, t || (window.requestAnimationFrame((function() {
        this.setStickyHeader(e), t = !1;
      }).bind(this)), t = !0);
    }).bind(this)), n.setAttribute("data-crefo-ui", "true"));
  },
  setStickyHeader: function(e) {
    var t = document.querySelector(".header-nav");
    !t.classList.contains(this.fixedClass) && e > document.querySelector(".header-primary").clientHeight ? t.classList.add(this.fixedClass) : e < t.clientHeight && t.classList.remove(this.fixedClass);
  },
  setBackdrop: function(e) {
    e ? (this.backdropOpen = !0, document.body.classList.add(this.activeClass)) : (this.backdropOpen = !1, document.body.classList.remove(this.activeClass));
  },
  closeBackdropAndSubmenues: function(e) {
    if (e && this.loginMenuOpen && (this.backdropOpen && this.setBackdrop(!1), document.querySelector(".login-menu").classList.remove("active"), this.loginMenuOpen = !this.loginMenuOpen), this.mainSubMenuOpen) {
      this.backdropOpen && this.setBackdrop(!1);
      for (var t = document.querySelectorAll(".main-menu .menu-item.has-submenu"), n = 0; n < t.length; n++)
        t[n].classList.remove("active");
      this.mainSubMenuOpen = !this.mainSubMenuOpen;
    }
  },
  initHeaderMainMenu: function() {
    var e = document.querySelectorAll(".main-menu .menu-item.has-submenu");
    if (e && e.length)
      for (var t = 0; t < e.length; t++)
        e[t].getAttribute("data-crefo-ui") !== "true" && (e[t].addEventListener("click", (function(n) {
          var a = n.target;
          if (a.nodeName !== "LI")
            for (; a.nodeName !== "LI"; )
              a = a.parentElement;
          a.classList.contains("has-submenu") || n.preventDefault();
          var r = a.classList.contains("active");
          this.closeBackdropAndSubmenues(!0), this.mainSubMenuOpen = !this.mainSubMenuOpen, r ? (a.classList.remove("active"), this.setBackdrop(!1)) : (a.classList.add("active"), this.setBackdrop(!0));
        }).bind(this)), e[t].setAttribute("data-crefo-ui", "true"));
  },
  initServiceMenuSubmenu: function() {
    var e = document.querySelectorAll(".service-menu .menu-item.has-submenu");
    if (e && e.length)
      for (var t = 0; t < e.length; t++) {
        var n = e[t], a = n.querySelector("a");
        a.getAttribute("data-crefo-ui") !== "true" && (a.addEventListener("click", function(r) {
          r.preventDefault();
          var s = r.target.parentElement;
          if (!s.classList.contains("has-submenu"))
            for (; !s.classList.contains("has-submenu"); )
              s = s.parentElement;
          s.querySelector(".service-submenu").classList.toggle("active");
        }), a.setAttribute("data-crefo-ui", "true"));
      }
  },
  initHeaderLoginMenu: function() {
    var e = document.querySelector(".login-menu"), t = document.querySelector(".login-menu--opener");
    e && t && t.getAttribute("data-crefo-ui") !== "true" && (t.addEventListener("click", (function(n) {
      n.preventDefault(), this.closeBackdropAndSubmenues(!1), this.loginMenuOpen = !this.loginMenuOpen, e.classList.toggle("active"), this.setBackdrop(!this.backdropOpen);
    }).bind(this)), t.setAttribute("data-crefo-ui", "true"));
  },
  initMinHeader: function() {
    document.querySelector(".header-nav").classList.add("fixed"), this.setContentMarginTop(70);
  },
  initMobileMenu: function() {
    var e = document.querySelector(".mobile-main-menu-opener"), t = document.querySelector(".header-nav .main-menu"), n = document.querySelectorAll(".service-menu > li:not(.has-submenu) > a");
    e && e.getAttribute("data-crefo-ui") !== "true" && (e.addEventListener("click", function(I) {
      I.preventDefault();
      var k = I.target;
      if (k.nodeName !== "I")
        for (; k.nodeName !== "I"; )
          k = k.firstElementChild;
      for (var H = document.querySelectorAll("nav.mobile-nav-wrapper li.has-submenu"), F = 0; F < H.length; F++)
        H[F].classList.remove("submenu-active");
      document.body.classList.toggle("mobile-menu-opened"), k.classList.toggle("icon-mobile-menu"), k.classList.toggle("icon-close");
    }), e.setAttribute("data-crefo-ui", "true"));
    var a = document.createElement("nav");
    a.className = "mobile-nav-wrapper";
    var r = document.createElement("ul");
    if (t) {
      document.querySelector(".header-nav").classList.add("has-mainmenu");
      for (var s = t.querySelectorAll(".menu-item:not(.show-if-sticky)"), c = 0; c < s.length; c++) {
        var i = s[c], $ = i.classList.contains("has-submenu"), f = document.createElement("li");
        f.className = "mobile-menu-item", $ && (f.className += " has-submenu", f.addEventListener("click", function(I) {
          I.preventDefault(), I.target.parentNode.classList.add("submenu-active");
        }));
        var l = document.createElement("a");
        l.href = i.querySelector("a").getAttribute("href"), l.textContent = i.querySelector("a").textContent, f.appendChild(l);
        var u = i.querySelectorAll(".main-menu--slide a");
        if ($ && u && u.length) {
          var x = document.createElement("div");
          x.className = "submenu-wrapper";
          var v = document.createElement("ul"), g = document.createElement("li");
          g.className = "mobile-submenu-item back";
          var o = document.createElement("a");
          o.href = "#", o.className = "link-icon-prev";
          var p = document.createElement("span");
          p.textContent = "Zurück", o.appendChild(p), g.appendChild(o), g.addEventListener("click", function(I) {
            I.preventDefault();
            var k = I.target.parentElement;
            if (!k.classList.contains("mobile-menu-item"))
              for (; !k.classList.contains("mobile-menu-item"); )
                k = k.parentElement;
            k.classList.remove("submenu-active");
          }), v.appendChild(g);
          for (var m = 0; m < u.length; m++) {
            var q = u[m], M = document.createElement("li");
            M.className = "mobile-submenu-item", M.innerHTML = q.outerHTML, v.appendChild(M);
          }
          if (n)
            for (var w = 0; w < n.length; w++) {
              var S = n[w], Z = document.createElement("li");
              Z.className = "mobile-submenu-item service-menu-item", Z.appendChild(S.cloneNode(!0)), v.appendChild(Z);
            }
          x.appendChild(v), f.appendChild(x);
        }
        r.appendChild(f);
      }
    }
    if (n) {
      document.querySelector(".header-nav").classList.add("has-servicemenu");
      for (var B = 0; B < n.length; B++) {
        var _ = n[B], N = document.createElement("li");
        N.className = "mobile-menu-item service-menu-item", N.appendChild(_.cloneNode(!0)), r.appendChild(N);
      }
    }
    if (t || n) {
      a.appendChild(r);
      var y = document.querySelector(".mobile-nav-wrapper");
      y && document.body.removeChild(y), document.body.appendChild(a);
    }
  },
  setContentMarginTop: function(e) {
    var t = document.querySelector(".main");
    t && (t.style.marginTop = e + "px");
  }
};
T.Header.init();
T.Input = {
  init: function() {
    var e = this;
    this.initPwMeter();
    for (var t = document.querySelectorAll("input:not([data-no-crefo-ui='true'])[type='text']"), n = document.querySelectorAll("input[type='email']"), a = document.querySelectorAll(".has-pwmeter input[type='password']"), r = document.querySelectorAll(".has-visible-toggle .pw-toggle"), s = 0; s < t.length; s++)
      t[s].getAttribute("data-crefo-ui") !== "true" && (t[s].addEventListener("keyup", function(l) {
        var u = e.getInputGroupWrapper(l.target);
        if (!l.target.value.length)
          u.classList.remove("is-valid"), u.classList.remove("has-error"), l.target.required && (e.setErrorMessage(u, "required"), u.classList.add("has-error"));
        else {
          var x = l.target.pattern, v = "", g = e.getLengthAttr(l.target, "max"), o = e.getLengthAttr(l.target, "min"), p = !0, m = !0, q = !0;
          if (x && x.length) {
            v = l.target.title;
            var M = RegExp(l.target.pattern);
            q = M.test(l.target.value);
          }
          g && g !== -1 && l.target.value.length > g && (p = !1), o && o !== -1 && l.target.value.length < o && (m = !1), !p || !m || !q ? (q || e.setErrorMessage(u, "pattern", v), m || e.setErrorMessage(u, "minLength", o), p || e.setErrorMessage(u, "maxLength", g), u.classList.add("has-error"), u.classList.remove("is-valid")) : (u.classList.remove("has-error"), u.classList.add("is-valid"));
        }
      }), t[s].setAttribute("data-crefo-ui", "true"));
    for (var c = 0; c < n.length; c++)
      n[c].getAttribute("data-crefo-ui") !== "true" && (n[c].addEventListener("keyup", function(l) {
        var u = e.getInputGroupWrapper(l.target);
        l.target.value.length ? e.validateHtml5Email(l.target.value) ? (u.classList.remove("has-error"), u.classList.add("is-valid")) : (u.classList.add("has-error"), u.classList.remove("is-valid")) : (u.classList.remove("is-valid"), l.target.required && (e.setErrorMessage(u, "required"), u.classList.add("has-error")));
      }), n[c].setAttribute("data-crefo-ui", "true"));
    for (var i = function(l) {
      r[l].getAttribute("data-crefo-ui") !== "true" && (r[l].addEventListener("click", function(u) {
        u.preventDefault();
        var x = e.getInputGroupWrapper(u.target);
        x.querySelector(".input-wrapper").classList.toggle("password-visible");
        var v = x.querySelector("input");
        v.type = v.type === "password" ? "text" : "password", r[l].title = v.type === "text" ? "Passwort verbergen" : "Passwort anzeigen";
      }), r[l].setAttribute("data-crefo-ui", "true"));
    }, $ = 0; $ < r.length; $++)
      i($);
    for (var f = 0; f < a.length; f++)
      a[f].getAttribute("data-crefo-ui") !== "true" && (a[f].addEventListener("keyup", function(l) {
        var u = e.getInputGroupWrapper(l.target);
        if (!l.target.value.length)
          l.target.required && (e.setErrorMessage(u, "required"), u.classList.add("has-error"));
        else if (l.target.value.length < 8)
          l.target.parentElement.classList.add("pwmeter-red"), l.target.parentElement.classList.remove("pwmeter-yellow", "pwmeter-green"), e.setErrorMessage(u, "minLength", 8), u.classList.add("has-error");
        else if (!e.validatePasswordRequirements(l.target.value))
          l.target.parentElement.classList.add("pwmeter-red"), l.target.parentElement.classList.remove("pwmeter-yellow", "pwmeter-green"), e.setErrorMessage(u, "password"), u.classList.add("has-error");
        else {
          var x = e.passwordMeterScore(l.target.value).score;
          u.classList.remove("has-error"), l.target.parentElement.classList.remove("pwmeter-red", "pwmeter-yellow", "pwmeter-green"), x <= 60 ? l.target.parentElement.classList.add("pwmeter-yellow") : x > 60 && l.target.parentElement.classList.add("pwmeter-green");
        }
      }), a[f].setAttribute("data-crefo-ui", "true"));
  },
  /**
   * Based on http://www.passwordmeter.com/ created by Jeff Todnem
   *
   * Created by: Stephan Schmitz <stephan.schmitz@sunzinet.com>
   * Created on: 2019-05-02
   *
   * License Information:
   * -------------------------------------------------------------------------
   *
   *
   * This program is free software; you can redistribute it and/or modify it
   * under the terms of the GNU General Public License as published by the
   * Free Software Foundation; either version 2 of the License, or (at your
   * option) any later version.
   *
   * This program is distributed in the hope that it will be useful, but
   * WITHOUT ANY WARRANTY; without even the implied warranty of
   * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU
   * General Public License for more details.
   *
   * You should have received a copy of the GNU General Public License along
   * with this program; if not, write to the Free Software Foundation, Inc.,
   * 59 Temple Place, Suite 330, Boston, MA 02111-1307 USA
   *
   **/
  passwordMeterScore: function(e) {
    var t = 0, n = 0, a = 0, r = 0, s = 0, c, i = 0, $ = 0, f = 0, l = c = 0, u = 0, x = 0, v = 0, g = 0, o = 0, p = 0, m = 0, q = 0, M = "", w = "", S = "", Z = "", B = 0, _ = 0, N = 0, y = 0, I = 0, k = 0, H = 0, F = 0, fe = 0, ie = 0, me = 0, ue = 0, ce = 0, he = 0, ee = 0, Y = 1;
    if (e) {
      for (var b = parseInt(4 * e.length), z = e.length, K = e.replace(/\s+/g, "").split(/\s*/), te = K.length, O = 0; O < te; O++) {
        K[O].match(/[A-Z]/g) ? (M !== "" && M + 1 === O && (l++, g++), M = O, t++) : K[O].match(/[a-z]/g) ? (w !== "" && w + 1 === O && (u++, g++), w = O, n++) : K[O].match(/[0-9]/g) ? (0 < O && O < te - 1 && s++, S !== "" && S + 1 === O && (x++, g++), S = O, a++) : K[O].match(/[^a-zA-Z0-9_]/g) && (0 < O && O < te - 1 && s++, Z !== "" && Z + 1 === O && (v++, g++), Z = O, r++);
        for (var oe = !1, ne = 0; ne < te; ne++)
          K[O] === K[ne] && O !== ne && (oe = !0, c += Math.abs(te / (ne - O)));
        oe && (f++, c = (oe = te - f) ? Math.ceil(c / oe) : Math.ceil(c));
      }
      for (v = 0; 23 > v; v++)
        g = "abcdefghijklmnopqrstuvwxyz".substring(v, parseInt(v + 3)), M = g.split("").reverse().join(""), (e.toLowerCase().indexOf(g) !== -1 || e.toLowerCase().indexOf(M) !== -1) && (o++, q++);
      for (v = 0; 8 > v; v++)
        g = "01234567890".substring(v, parseInt(v + 3)), M = g.split("").reverse().join(""), (e.toLowerCase().indexOf(g) !== -1 || e.toLowerCase().indexOf(M) !== -1) && (p++, q++);
      for (v = 0; 8 > v; v++)
        g = "!\"#$%&'()*+,-./:;<=>?[\\]^`{|}~".substring(v, parseInt(v + 3)), M = g.split("").reverse().join(""), (e.toLowerCase().indexOf(g) !== -1 || e.toLowerCase().indexOf(M) !== -1) && (m++, q++);
      for (q = b, 0 < t && t < z && (b = parseInt(b + 2 * (z - t)), B = parseInt(2 * (z - t))), 0 < n && n < z && (b = parseInt(b + 2 * (z - n)), _ = parseInt(2 * (z - n))), 0 < a && a < z && (b = parseInt(b + 4 * a), N = parseInt(4 * a)), 0 < r && (b = parseInt(b + 6 * r), y = parseInt(6 * r)), 0 < s && (b = parseInt(b + 2 * s), I = parseInt(2 * s)), (0 < n || 0 < t) && r === 0 && a === 0 && (b = parseInt(b - z), i = z, H = -z), n === 0 && t === 0 && r === 0 && 0 < a && (b = parseInt(b - z), $ = z, F = -z), 0 < f && (b = parseInt(b - c), fe = -c), 0 < l && (b = parseInt(b - 2 * l), ie = -parseInt(2 * l)), 0 < u && (b = parseInt(b - 2 * u), me = -parseInt(2 * u)), 0 < x && (b = parseInt(b - 2 * x), ue = -parseInt(2 * x)), 0 < o && (b = parseInt(b - 3 * o), ce = -parseInt(3 * o)), 0 < p && (b = parseInt(b - 3 * p), he = -parseInt(3 * p)), 0 < m && (b = parseInt(b - 3 * m), ee = -parseInt(3 * m)), c = [z, t, n, a, r], v = ["nLength", "nAlphaUC", "nAlphaLC", "nNumber", "nSymbol"], g = c.length, S = M = 0; S < g; S++)
        w = v[S] === "nLength" ? 7 : 0, (c[S] === parseInt(w + 1) || c[S] > parseInt(w + 1)) && M++;
      return c = M, c > (8 <= e.length ? 3 : 4) && (b = parseInt(b + 2 * c), k = parseInt(2 * c)), 100 < b ? b = 100 : 0 > b && (b = 0), 0 <= b && 20 > b ? Y = 1 : 20 <= b && 40 > b ? Y = 2 : 40 <= b && 60 > b ? Y = 3 : 60 <= b && 80 > b ? Y = 4 : 80 <= b && 100 >= b && (Y = 5), {
        score: b,
        complexity: Y,
        additions: {
          numberOfCharacters: {
            count: z,
            bonus: q
          },
          uppercaseLetters: {
            count: t,
            bonus: B
          },
          lowercaseLetters: {
            count: n,
            bonus: _
          },
          numbers: {
            count: a,
            bonus: N
          },
          symbols: {
            count: r,
            bonus: y
          },
          middleNumbersOrSymbols: {
            count: s,
            bonus: I
          },
          requirements: {
            count: c,
            bonus: k
          }
        },
        deductions: {
          lettersOnly: {
            count: i,
            bonus: H
          },
          numbersOnly: {
            count: $,
            bonus: F
          },
          repeatCharacters: {
            count: f,
            bonus: fe
          },
          consecutiveUppercaseLetters: {
            count: l,
            bonus: ie
          },
          consecutiveLowercaseLetters: {
            count: u,
            bonus: me
          },
          consecutiveNumbers: {
            count: x,
            bonus: ue
          },
          sequentialLetters: {
            count: o,
            bonus: ce
          },
          sequentialNumbers: {
            count: p,
            bonus: he
          },
          sequentialSymbols: {
            count: m,
            bonus: ee
          }
        }
      };
    }
    return !1;
  },
  initPwMeter: function() {
    for (var e = document.querySelectorAll(".has-pwmeter"), t = 0; t < e.length; t++)
      e[t].classList.add("pwmeter-red");
  },
  getInputGroupWrapper: function(e) {
    var t = "input-group", n = e.parentElement;
    if (!n.classList.contains(t))
      for (; !n.classList.contains(t); )
        n = n.parentElement;
    return n;
  },
  validatePasswordRequirements: function(e) {
    var t = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9!@#$%^&*])(?=.{8,})");
    return t.test(e);
  },
  validateHtml5Email: function(e) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(e);
  },
  setErrorMessage: function(e, t, n) {
    var a = e.querySelector(".error-msg"), r = e.querySelector("label").textContent;
    if (a) {
      var s = "Fehler";
      switch (t) {
        case "required":
          s = r + " ist ein Pflichtfeld.";
          break;
        case "pattern":
          s = n;
          break;
        case "minLength":
          s = r + " muss mindestens " + n + " Zeichen enthalten.";
          break;
        case "maxLength":
          s = r + " darf maximal " + n + " Zeichen enthalten.";
          break;
        case "password":
          s = "Passwort muss Groß- und Kleinbuchstaben sowie eine Zahl oder ein Sonderzeichen enthalten.";
      }
      a.innerHTML = "<span>" + s + "</span>";
    }
  },
  // F**ing IE doesn't set the maxLength/minLength attribute, so we need to workaround
  getLengthAttr: function(e, t) {
    var n = !1;
    if (e[t + "Length"])
      n = e[t + "Length"];
    else
      for (var a = 0; a < e.attributes.length; a++)
        if (e.attributes[a].nodeName === t + "length") {
          n = e.attributes[a].nodeValue;
          break;
        }
    return n;
  }
};
T.Input.init();
T.Modal = {
  closeAll: function(e, t) {
    //!e || console.dir(e)
    var n = document.querySelectorAll(".crefo-ui-modal");
    if (n && n.length) {
      for (var a = 0; a < n.length; a++) {
        var r = n[a];
        r.dataset.noCrefoUi !== "true" && r.parentNode.removeChild(r);
      }
      setTimeout(function() {
        !e || e(t);
      }, 100);
    }
  },
  show: function(e) {
    var t = this;
    if (e) {
      var n = "crefo-ui-modal";
      e.dataQa && typeof e.dataQa == "string" && e.dataQa.length && (n += "--".concat(e.dataQa));
      var a = ["success", "error", "info", "warning"], r = e.icon && typeof e.icon == "string" && a.indexOf(e.icon) !== -1, s = document.createElement("div");
      s.className = "crefo-ui-modal", r && (s.className += " modal-statusicon modal-".concat(e.icon)), s.setAttribute("data-qa", n), s.addEventListener("click", (function(g) {
        g.target.classList.contains("crefo-ui-modal") && this.closeAll(e.cancelCallback, g);
      }).bind(this));
      var c = document.createElement("div");
      c.className = "modal-content";
      var i = document.createElement("div");
      i.className = "modal-header";
      var $ = document.createElement("span");
      if ($.className = "modal-close", $.addEventListener("click", (function(g) {
        this.closeAll(e.cancelCallback, g);
      }).bind(this)), r) {
        var f = document.createElement("i");
        f.className = "crefo-ui-icon", e.icon === "success" ? f.className += " icon-circle-success" : e.icon === "error" ? f.className += " icon-circle-error" : e.icon === "info" ? f.className += " icon-circle-info" : e.icon === "warning" && (f.className += " icon-circle-warning"), i.appendChild(f);
      }
      var l = document.createElement("h2");
      l.className = "mt", l.textContent = e.title || "";
      var u = document.createElement("div");
      if (u.className = "modal-body", u.innerHTML = e.content || "", i.appendChild(l), i.appendChild($), c.appendChild(i), e.buttons && (e.buttons.confirm || e.buttons.cancel)) {
        var x = function(g, o, p) {
          var m = document.createElement("button");
          m.className = "btn btn-default mt", p && (m.className += " ml"), m.textContent = g, m.addEventListener("click", (function(q) {
            this.closeAll(o, q);
          }).bind(t)), u.appendChild(m);
        };
        if (e.buttons.cancel && e.buttons.cancel.length && x(e.buttons.cancel, e.cancelCallback), e.buttons.confirm && e.buttons.confirm.length) {
          var v = !!e.buttons.cancel;
          x(e.buttons.confirm, e.confirmCallback, v);
        }
      }
      c.appendChild(u), s.appendChild(c), this.closeAll(), document.body.appendChild(s), document.addEventListener("keydown", (function g(o) {
        (o.key === "Escape" || o.key === "Enter") && (o.preventDefault(), this.closeAll(e.cancelCallback, o), document.removeEventListener("keydown", g));
      }).bind(this));
    }
  }
};
T.Select = {
  update: function() {
    for (var e = document.getElementsByClassName("crefo-ui-select"), t = 0; t < e.length; t++) {
      var n = e[t].querySelector("select");
      if (n.selectedIndex >= 0) {
        var a = e[t].querySelector(".select-selected");
        a.innerHTML = n.options[n.selectedIndex].text;
      }
    }
  },
  init: function() {
    var e = this, t, n, a, r, s, c, i;
    for (a = document.getElementsByClassName("crefo-ui-select"), t = 0; t < a.length; t++)
      if (a[t].getAttribute("data-crefo-ui") !== "true") {
        r = a[t].querySelector("select"), s = document.createElement("DIV"), s.setAttribute("class", "select-selected"), r.hasAttribute("tabindex") ? (s.setAttribute("tabindex", r.getAttribute("tabindex")), s.tabIndex = r.tabIndex) : (s.setAttribute("tabindex", "0"), s.tabIndex = 0);
        var $ = r.selectedIndex < 0 ? 0 : r.selectedIndex;
        for (s.innerHTML = r.options[$].innerHTML, r.parentElement.appendChild(s), c = document.createElement("DIV"), c.setAttribute("class", "select-items select-hide"), c.setAttribute("role", "listbox"), n = 0; n < r.length; n++)
          i = document.createElement("DIV"), i.setAttribute("role", "option"), i.innerHTML = r.options[n].innerHTML, i.addEventListener("click", (function(f) {
            var l, u, x, v, g;
            for (v = f.currentTarget.parentNode.parentNode.getElementsByTagName("select")[0], g = f.currentTarget.parentNode.previousSibling, u = 0; u < v.length; u++)
              if (v.options[u].innerHTML == f.currentTarget.innerHTML) {
                for (v.options[u].setAttribute("selected", "selected"), v.selectedIndex = u, g.innerHTML = f.currentTarget.innerHTML, l = f.currentTarget.parentNode.getElementsByClassName("same-as-selected"), x = 0; x < l.length; x++)
                  l[x].removeAttribute("class");
                f.currentTarget.setAttribute("class", "same-as-selected"), setTimeout((function() {
                  this.closeAllSelects();
                }).bind(this), 0);
              } else
                v.options[u].removeAttribute("selected");
            var o = null;
            typeof Event == "function" ? o = new Event("change") : typeof document.createEvent == "function" && typeof window.Event != "function" && (o = document.createEvent("Event"), o.initEvent("change", !1, !1)), o !== null && v.dispatchEvent(o), g.click();
          }).bind(this)), c.appendChild(i);
        r.parentElement.appendChild(c), r.style.display = "none", r.parentElement.addEventListener("click", function(f) {
          e.onOpenSelectList(f);
        }), s.addEventListener("keydown", function(f) {
          var l = f.target;
          if (!l.classList.contains("select-selected"))
            for (; !l.classList.contains("select-selected"); )
              l = l.parentElement;
          l.classList.contains("select-arrow-active") || e.onOpenSelectList(f);
        }), a[t].setAttribute("data-crefo-ui", "true");
      }
  },
  onOpenSelectList: function(e, t) {
    var n = e.target;
    if (!n.classList.contains("input-wrapper"))
      for (; !n.classList.contains("input-wrapper"); )
        n = n.parentElement;
    e.stopPropagation(), this.closeAllOtherSelects(n.querySelector(".select-selected")), n.classList.toggle("show-options"), n.querySelector(".select-items").classList.toggle("select-hide"), n.querySelector(".select-selected").classList.toggle("select-arrow-active"), document.addEventListener("click", (function a() {
      this.closeAllSelects(), document.removeEventListener("click", a);
    }).bind(this));
  },
  closeAllSelects: function() {
    for (var e = document.querySelectorAll(".show-options"), t = document.querySelectorAll(".select-selected"), n = document.querySelectorAll(".select-items"), a = 0; a < e.length; a++)
      e[a].classList.remove("show-options");
    for (var r = 0; r < t.length; r++)
      t[r].classList.remove("select-arrow-active");
    for (var s = 0; s < n.length; s++)
      n[s].classList.add("select-hide");
  },
  closeAllOtherSelects: function(e) {
    var t, n, a, r = [];
    for (t = document.getElementsByClassName("select-items"), n = document.getElementsByClassName("select-selected"), a = 0; a < n.length; a++)
      e === n[a] ? r.push(a) : n[a].classList.remove("select-arrow-active");
    for (a = 0; a < t.length; a++)
      r.indexOf(a) && t[a].classList.add("select-hide");
  }
};
T.Select.init();
T.Tooltips = {
  init: function() {
    var e = document.querySelectorAll(".crefo-ui-tooltip");
    if (e && e.length) {
      for (var t = 0; t < e.length; t++)
        if (e[t].getAttribute("data-crefo-ui") !== "true") {
          var n = e[t], a = n.getAttribute("data-tooltip-text");
          if (!n.querySelector(".crefo-tooltip")) {
            var r = document.createElement("span");
            r.className = "crefo-tooltip", r.textContent = a || "";
            var s = document.createElement("span");
            s.className = "inline-wrapper", s.innerHTML = n.innerHTML, s.addEventListener("mouseover", function(c) {
              var i = c.target;
              if (!i.classList.contains("inline-wrapper"))
                for (; !i.classList.contains("inline-wrapper"); )
                  i = i.parentElement;
              var $ = i.getBoundingClientRect(), f = {
                left: $.left,
                right: document.body.offsetWidth - ($.left + $.width)
              }, l = !1;
              i.parentElement.classList.contains("tooltip-left") && f.left < 150 && (i.parentElement.classList.remove("tooltip-left"), i.parentElement.classList.add("tooltip-right"), l = !0), i.parentElement.classList.contains("tooltip-right") && f.right < 150 && (i.parentElement.classList.remove("tooltip-right"), l ? i.parentElement.classList.add("tooltip-top") : i.parentElement.classList.add("tooltip-left")), i.classList.add("active");
            }), s.addEventListener("mouseout", function(c) {
              var i = c.target;
              if (!i.classList.contains("inline-wrapper"))
                for (; !i.classList.contains("inline-wrapper"); )
                  i = i.parentElement;
              i.classList.remove("active");
            }), s.appendChild(r), n.innerHTML = "", n.appendChild(s);
          }
          e[t].setAttribute("data-crefo-ui", "true");
        }
    }
  }
};
T.Tooltips.init();
function ut() {
  const e = () => {
    for (let n in T)
      typeof T[n].init == "function" && T[n].init();
  }, t = () => {
    for (let n in T)
      typeof T[n].init == "function" && T[n].init(), typeof T[n].update == "function" && T[n].update();
  };
  _e(e), Re(t);
}
const ct = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, r] of t)
    n[a] = r;
  return n;
}, dt = (e) => ($e("data-v-02787b8b"), e = e(), Ne(), e), pt = {
  key: 0,
  class: "loader-wrapper"
}, gt = /* @__PURE__ */ dt(() => /* @__PURE__ */ Q("div", { class: "lds-ring" }, [
  /* @__PURE__ */ Q("div", { class: "border-crefo-blue" }),
  /* @__PURE__ */ Q("div", { class: "border-crefo-blue" }),
  /* @__PURE__ */ Q("div", { class: "border-crefo-blue" }),
  /* @__PURE__ */ Q("div", { class: "border-crefo-blue" })
], -1)), ft = [
  gt
], mt = {
  __name: "crefo-autosuggest-input",
  props: {
    value: {
      type: String,
      default: null
    },
    suggestions: {
      type: Array,
      required: !0
    },
    additionalSuggestions: {
      type: Array,
      required: !1,
      default: () => []
    },
    searching: {
      type: Boolean,
      required: !1,
      default: !1
    },
    getSuggestionValue: {
      type: Function,
      required: !1,
      default: null
    },
    idAutoSuggest: {
      type: String,
      required: !1,
      default: "crefo-autosuggest-input_" + (Math.floor(Math.random() * 8999999) + 1e6)
    },
    idInput: {
      type: String,
      required: !1,
      default: null
    },
    classInput: {
      type: String,
      required: !1,
      default: null
    },
    placeholderInput: {
      type: String,
      required: !1,
      default: ""
    },
    dataQa: {
      type: String,
      required: !1,
      default: "crefo-autosuggest-input"
    },
    searchDelay: {
      type: Number,
      required: !1,
      default: 250
    },
    nameInput: {
      type: String,
      required: !1,
      default: "crefo-autosuggest-input"
    }
  },
  emits: ["crefo-autosuggest-input-suggestions-closed", "crefo-autosuggest-input-suggestions-opened", "crefo-autosuggest-input-search", "crefo-autosuggest-input-changed", "crefo-autosuggest-input-additional-item-selected", "crefo-autosuggest-input-item-selected", "crefo-autosuggest-input-item-changed"],
  setup(e, { emit: t }) {
    const n = e, {
      suggestions: a,
      additionalSuggestions: r,
      searching: s,
      getSuggestionValue: c,
      idAutoSuggest: i,
      idInput: $,
      classInput: f,
      placeholderInput: l,
      searchDelay: u,
      dataQa: x,
      nameInput: v
    } = we(n);
    ut();
    const g = R(n.value || null), o = G({
      get() {
        return g.value;
      },
      set(y) {
        g.value = y;
      }
    }), p = R(!1), m = R(null), q = R(!1), M = (y) => typeof c.value == "function" ? c.value(y.item) : (I) => I.item, w = (y) => {
      t("crefo-autosuggest-input-changed", y), N(y), q.value = y !== null && y !== "";
    }, S = (y, I) => {
      y !== null && y.name === "default" ? t("crefo-autosuggest-input-item-selected", y.item, I) : y !== null && y.name === "additional" && t("crefo-autosuggest-input-additional-item-selected", y.item, I);
    }, Z = (y, I) => {
      y !== null && y.name === "default" ? t("crefo-autosuggest-input-item-changed", y.item, I) : y !== null && y.name === "additional" && t("crefo-autosuggest-input-additional-item-changed", y.item, I);
    }, B = () => {
      p.value = !0, t("crefo-autosuggest-input-suggestions-opened");
    }, _ = () => {
      p.value = !1, t("crefo-autosuggest-input-suggestions-closed");
    }, N = (y, I = !1) => {
      I === !1 ? (m.value !== null && clearTimeout(m.value), m.value = setTimeout(() => {
        N(y, !0);
      }, u.value)) : t("crefo-autosuggest-input-search", y);
    };
    return (y, I) => (V(), P("div", {
      class: se(["input-wrapper input-wrapper--crefo-autosuggest", {
        "input-wrapper--crefo-autosuggest--open": p.value,
        "input-wrapper--crefo-autosuggest--focus": q.value
      }])
    }, [
      ye(h(it), {
        suggestions: [{ name: "default", data: h(a) }].concat([{ name: "additional", data: h(r) }]),
        "input-props": { id: h($), class: h(f), placeholder: h(l), "data-qa": h(x), "data-no-crefo-ui": !0, name: h(v) },
        "get-suggestion-value": M,
        "component-attr-id-autosuggest": h(i),
        modelValue: o.value,
        "onUpdate:modelValue": I[0] || (I[0] = (k) => o.value = k),
        onInput: w,
        onSelected: S,
        onItemChanged: Z,
        onOpened: B,
        onClosed: _
      }, {
        default: J(({ suggestion: k }) => [
          k.name === "default" ? D(y.$slots, "default", {
            key: 0,
            suggestion: k.item
          }, () => [
            le(U(k.item), 1)
          ], !0) : D(y.$slots, "additional-suggestions", {
            key: 1,
            suggestion: k.item
          }, () => [
            le(U(k.item), 1)
          ], !0)
        ]),
        "after-section-additional": J(() => [
          D(y.$slots, "after-suggestions", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["suggestions", "input-props", "component-attr-id-autosuggest", "modelValue"]),
      ye(je, {
        name: "fade",
        duration: "450"
      }, {
        default: J(() => [
          h(s) ? (V(), P("div", pt, ft)) : re("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}, ht = /* @__PURE__ */ ct(mt, [["__scopeId", "data-v-02787b8b"]]);
(function() {
  (function(e, t) {
    try {
      const n = "style-npm-crefo-error-message";
      if (typeof document < "u" && document.getElementById(n) === null && typeof e == "string" && e.length) {
        const a = document.createElement("style");
        a.id = n, a.type = "text/css", a.appendChild(document.createTextNode(e)), document.head.appendChild(a);
      }
    } catch (n) {
      console.error("vite-plugin-css-injected-by-js", n);
    }
  })(".npm-crefo-error-message.crefo-ui-alert[data-v-3ed57e23] a,.npm-crefo-error-message.crefo-ui-alert[data-v-3ed57e23] a:hover,.npm-crefo-error-message.crefo-ui-alert[data-v-3ed57e23] a:visited,.npm-crefo-error-message.crefo-ui-alert[data-v-3ed57e23] a:active{color:#fff;text-decoration:underline}");
})();
let de;
de = {
  de: {
    now: "Jetzt",
    "Error.302": "Der Service antwortet mit einer Weiterleitung auf Ihre Anfrage anstelle der erwarteten Daten. Bitte probieren Sie es später erneut. Bei Wiederauftreten wenden Sie sich bitte an den VVC-Support.",
    "Error.400": "Das war leider nicht erfolgreich!",
    "Error.401": "Zugriff verweigert!",
    "Error.403": "Zugriff verweigert!",
    "Error.404": "Angeforderte Ressource nicht gefunden",
    "Error.500": "Der Service ist aktuell nicht erreichbar. Bitte probieren Sie es erneut. Bei Wiederauftreten wenden Sie sich bitte an den VVC-Support.",
    "Error.CorrelationId.Prefix": "Fehler-Id:"
  },
  en: {
    now: "Now",
    "Error.302": "The service is responding with a redirect to your request instead of the expected data. Please try again later. In the event of recurrence, please contact VVC Support.",
    "Error.400": "Unfortunately, that was not successful",
    "Error.401": "Access denied!",
    "Error.403": "Access denied!",
    "Error.404": "Requested resource not found",
    "Error.500": "The service is currently unavailable. Please try again. If this occurs again, please contact VVC support.",
    "Error.CorrelationId.Prefix": "Error-Id:"
  },
  fr: {
    now: "Maintenant",
    "Error.302": "Le service répond par une redirection à votre demande au lieu des données attendues. Veuillez réessayer plus tard. En cas de récidive, veuillez contacter le service d'assistance VVC.",
    "Error.400": "Malheureusement, cela n'a pas été le cas !",
    "Error.401": "Accès refusé !",
    "Error.403": "Accès refusé !",
    "Error.404": "La ressource demandée n'a pas été trouvée",
    "Error.500": "Le service est actuellement indisponible. Veuillez réessayer. Si cela se reproduit, veuillez contacter le service d'assistance de VVC.",
    "Error.CorrelationId.Prefix": "Error-Id :"
  }
};
const ge = (e, t, n) => {
  let a = "";
  if (typeof e != "string" || e.length === 0)
    return a;
  if (typeof de.de[e] == "string" && (a = de.de[e]), typeof t == "object" && t !== null)
    if (vt(e, t))
      typeof n == "object" && n !== "null" ? a = t.t(e, n) : a = t.t(e);
    else {
      let r = "de";
      typeof t.locale == "string" && t.locale.length && (r = t.locale.substring(0, 2).toLowerCase()), r in de && typeof de[r][e] == "string" && (a = de[r][e]);
    }
  return a;
}, Me = (e, t) => ge(e, t) !== "";
function vt(e, t) {
  if (typeof e != "string" || e.length === 0 || typeof t != "object" || t === null || typeof t.t != "function" || typeof t.te != "function")
    return !1;
  if (e.includes("."))
    return t.t(e) !== e;
  {
    const n = t.te(e);
    return n ? !0 : !n && t.fallbackLocale !== !1 ? t.te(e, t.fallbackLocale) : t.te(e, "de_DE");
  }
}
const bt = Ze({
  name: "CorrelationIdMessage",
  props: {
    correlationId: {
      type: String,
      default: ""
    },
    dataQa: {
      type: String,
      default: ""
    },
    i18n: {
      type: Object,
      default: null
    }
  },
  computed: {
    correlationIdPrefix() {
      const e = "Fehler-Id:";
      let t = ge("Error.CorrelationId.Prefix", this.i18n);
      return t.length ? t : e;
    }
  }
}), Oe = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, r] of t)
    n[a] = r;
  return n;
}, yt = ["data-qa"];
function Lt(e, t, n, a, r, s) {
  return V(), P("div", {
    class: "pt-small text-small",
    "data-qa": e.dataQa + "-correlation-id"
  }, U(e.correlationIdPrefix) + " " + U(e.correlationId), 9, yt);
}
const Ct = /* @__PURE__ */ Oe(bt, [["render", Lt]]), Ce = "Error.", wt = (e, t = "", n = null) => {
  const a = Et(e);
  return {
    statusCode: Be(e),
    correlationId: a,
    errorMessage: St(e, t, n, a),
    responseError: xt(e),
    responseMessage: kt(e),
    requestUrl: It(e)
  };
}, Be = (e) => {
  const t = Le(e, "status");
  return typeof t == "number" ? t : 0;
}, Et = (e) => {
  const t = Le(e, "headers");
  if (typeof t == "object" && t !== null) {
    if (typeof t.correlationId == "string")
      return t.correlationId;
    if (typeof t.correlationid == "string")
      return t.correlationid;
  }
  return "";
}, St = (e, t = "", n = null, a = "") => {
  const r = Be(e);
  if (t.length) {
    const s = Ce + t + ".";
    if (Me(s + r, n))
      return ge(s + r, n, { correlationId: a });
    if (Me(s + "500", n))
      return ge(s + "500", n, { correlationId: a });
  }
  return At(r, n, { correlationId: a });
}, At = (e, t, n) => {
  const a = ge(Ce + e, t, n);
  return a.length ? a : ge(Ce + "500", t, n);
}, xt = (e) => {
  const t = He(e);
  if ("error" in t) {
    const n = typeof t.error;
    if (["string", "number", "boolean"].includes(n))
      return String(t.error);
  }
  return "";
}, kt = (e) => {
  const t = He(e);
  if ("message" in t) {
    const n = typeof t.message;
    if (["string", "number", "boolean"].includes(n))
      return String(t.message);
  }
  return "";
}, It = (e) => {
  let t = Le(e, "responseURL");
  if (typeof t != "string" || t.length === 0)
    return "";
  const n = "meine.creditreform.de/", a = t.indexOf(n);
  return a > 0 && (t = t.substring(a + n.length - 1)), t.indexOf("?") >= 0 && (t = t.substring(0, t.indexOf("?"))), t = t.replace(new RegExp("[0-9]+", "g"), "XXXX"), t;
};
function He(e) {
  if (typeof e != "object" || e === null)
    return {};
  if (e instanceof Error)
    return {
      message: e.message
    };
  let t = Le(e, "data");
  if (typeof t == "object" && t !== null)
    return t;
  if (typeof t == "string" && t.length)
    try {
      if (t = JSON.parse(t), typeof t == "object" && t !== null)
        return t;
    } catch {
    }
  return {};
}
function Le(e, t) {
  if (typeof e != "object" || e === null || typeof t != "string" || t.length === 0)
    return null;
  function n(a, r) {
    return typeof a == "object" && a !== null && r in a ? a[r] : null;
  }
  if (t in e)
    return n(e, t);
  if ("response" in e) {
    const a = n(e.response, t);
    if (a !== null)
      return a;
  }
  return "request" in e ? n(e.request, t) : null;
}
function Mt(e = "action", t = {}) {
  if (!_t())
    return;
  const n = qt();
  window.wtSmart.session.data.set({
    loginStatus: n[4] === "-" ? "not_logged_in" : "logged_in",
    parameter: n
  }), window.wtSmart.action.data.set({
    name: e,
    parameter: t
  }), window.wtSmart.track();
}
function _t() {
  return typeof window.wtSmart == "object" && window.wtSmart !== null && window.wtSmart.session && window.wtSmart.action && window.wtSmart.track;
}
function qt() {
  const e = {
    2: "-",
    3: "-",
    4: "-"
  };
  return typeof window.keycloak == "object" && window.keycloak !== null && typeof window.keycloak.tokenParsed == "object" && window.keycloak.tokenParsed !== null && (typeof window.keycloak.tokenParsed.cr_membernumber == "string" && window.keycloak.tokenParsed.cr_membernumber.length && (e[2] = window.keycloak.tokenParsed.cr_membernumber.substring(0, 3), e[3] = window.keycloak.tokenParsed.cr_membernumber), typeof window.keycloak.tokenParsed.cr_id == "string" && window.keycloak.tokenParsed.cr_id.length && (e[4] = $t(window.keycloak.tokenParsed.cr_id))), e;
}
function $t(e) {
  return e.substring(0, 1) + e.substring(1, 5).replace(new RegExp("[0-4]", "g"), "x").replace(new RegExp("[5-9]", "g"), "X") + "xxxxxxxxxxx";
}
const Nt = Ze({
  name: "CrefoErrorMessage",
  components: { CorrelationIdMessage: Ct },
  props: {
    ajaxError: {
      type: Object,
      default: null
    },
    errorPrefix: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "error"
    },
    dataQa: {
      type: String,
      default: "error-message"
    },
    webtrekkActionId: {
      type: String,
      default: ""
    },
    i18n: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      lastErrorTrackingId: ""
    };
  },
  computed: {
    isDefaultSlotInUse() {
      return !!this.$slots.default;
    },
    localI18n() {
      return typeof this.i18n == "object" && this.i18n !== null ? this.i18n : typeof this.$i18n == "object" && this.$i18n !== null && typeof this.$t == "function" && typeof this.$te == "function" ? {
        t: this.$t,
        te: this.$te,
        locale: this.$i18n.locale,
        fallbackLocale: this.$i18n.fallbackLocale || !1
      } : null;
    },
    parsedErrorObject() {
      const e = this.getParsedErrorObject(this.ajaxError, this.errorPrefix, this.localI18n);
      return this.reportErrorToWebtrekk(e, this.webtrekkActionId), e;
    }
  },
  methods: {
    getParsedErrorObject(e, t, n) {
      return wt(e, t, n);
    },
    reportErrorToWebtrekk(e, t) {
      if (e.statusCode === 0 && e.errorMessage === "")
        return;
      const n = String(e.statusCode) + e.errorMessage + e.correlationId;
      if (n !== this.lastErrorTrackingId) {
        this.lastErrorTrackingId = n;
        let a = "error_";
        t.length ? a += t : typeof __APP_NAME__ == "string" && __APP_NAME__.includes("/") ? a += __APP_NAME__.split("/")[1] : a += "custom", Mt(
          "crefo_error_message",
          {
            2: String(e.statusCode),
            3: e.errorMessage,
            5: String(e.statusCode),
            6: a,
            7: e.requestUrl,
            8: e.correlationId,
            16: e.responseMessage.substring(0, 250),
            17: e.responseError.substring(0, 250)
          }
        );
      }
    }
  }
}), Zt = ["data-qa"], Ot = ["data-qa", "innerHTML"];
function Bt(e, t, n, a, r, s) {
  const c = Ue("correlation-id-message");
  return V(), P("div", {
    class: se(["npm-crefo-error-message crefo-ui-alert", e.type])
  }, [
    e.isDefaultSlotInUse ? (V(), P("div", {
      key: 0,
      "data-qa": e.dataQa
    }, [
      D(e.$slots, "default", {
        correlationId: e.parsedErrorObject.correlationId
      }, void 0, !0)
    ], 8, Zt)) : (V(), P("div", {
      key: 1,
      "data-qa": e.dataQa,
      innerHTML: e.parsedErrorObject.errorMessage
    }, null, 8, Ot)),
    e.parsedErrorObject.correlationId ? (V(), Se(c, {
      key: 2,
      "correlation-id": e.parsedErrorObject.correlationId,
      "data-qa": e.dataQa,
      i18n: e.localI18n
    }, null, 8, ["correlation-id", "data-qa", "i18n"])) : re("", !0)
  ], 2);
}
const Ae = /* @__PURE__ */ Oe(Nt, [["render", Bt], ["__scopeId", "data-v-3ed57e23"]]), Ht = {
  install: (e) => {
    e.component("CrefoErrorMessage", Ae);
  }
};
Ae.install = Ht.install;
const Ve = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, r] of t)
    n[a] = r;
  return n;
}, Vt = {}, jt = {
  width: "198",
  height: "107",
  viewBox: "0 0 198 107",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tt = /* @__PURE__ */ We('<path d="M118.555 111.643C93.8918 136.657 55.9577 129.247 50.3635 128.07C43.2994 126.581 26.5169 123.013 13.9811 108.938C-5.21057 87.4134 -3.29141 53.7352 11.5311 31.0347C15.8186 24.4088 30.3552 4.76646 57.591 0.532172C59.1835 0.296934 87.6443 -3.74132 110.552 14.7249C113.655 17.1949 118.637 21.7036 123.006 28.2903C136.522 48.5991 142.933 86.9037 118.555 111.643Z" fill="#EDECE6"></path><path d="M123.705 21.152C123.705 20.642 123.472 20.1712 123.122 19.8181C122.772 19.465 122.266 19.3081 121.8 19.3081L81.7899 20.6028C80.779 20.642 79.9625 21.5051 80.0013 22.5251L81.9843 89.3765C82.0232 90.3966 82.8397 91.1812 83.8507 91.1812L123.044 90.7889C123.549 90.7889 124.016 90.5927 124.366 90.2397C124.716 89.8866 124.91 89.4158 124.871 88.9058L123.705 21.152Z" fill="#95B0DD"></path><g opacity="0.43"><path d="M119.544 24.4083H83.9283C83.5783 24.4083 83.3062 24.6044 83.3062 24.9183L83.345 28.0569C83.345 28.3707 83.6172 28.763 83.9671 28.763L119.7 28.8023C120.05 28.8023 120.322 28.4099 120.322 28.0961L120.205 24.9575C120.205 24.6044 119.894 24.4083 119.544 24.4083Z" fill="white"></path><path d="M119.777 31.1954L84.0059 31.117C83.656 31.117 83.3838 31.47 83.3838 31.7839L83.4227 35.0009C83.4227 35.354 83.6948 35.6679 84.0448 35.6679L119.933 35.7856C120.283 35.7856 120.555 35.4717 120.555 35.1186L120.438 31.9016C120.438 31.5093 120.127 31.1954 119.777 31.1954Z" fill="white"></path><path d="M120.011 38.4141L84.084 38.2964C83.7341 38.2964 83.4619 38.4534 83.4619 38.8065L83.5008 42.0235C83.5008 42.3766 83.773 42.612 84.1229 42.612L120.167 42.7689C120.517 42.7689 120.789 42.5335 120.789 42.1804L120.672 38.9241C120.672 38.5711 120.361 38.4141 120.011 38.4141Z" fill="white"></path><path d="M120.244 45.4759L84.1617 45.2797C83.8117 45.2797 83.5396 45.5151 83.5396 45.829L83.5784 49.0852C83.5784 49.4383 83.8506 49.6345 84.2394 49.6345L120.439 49.8699C120.789 49.8699 121.1 49.6737 121.061 49.3206L120.944 46.0251C120.905 45.7113 120.594 45.4759 120.244 45.4759Z" fill="white"></path><path d="M120.477 52.5769L84.2393 52.3415C83.8894 52.3415 83.6172 52.6554 83.6172 52.9692L83.6561 56.2647C83.6561 56.6178 83.9671 56.9709 84.3171 56.9709L120.633 57.2847C120.983 57.2847 121.255 56.9316 121.255 56.5786L121.138 53.2438C121.138 52.8907 120.827 52.5769 120.477 52.5769Z" fill="white"></path><path d="M120.711 59.7564L84.2784 59.4425C83.9284 59.4425 83.6562 59.7956 83.6562 60.1487L83.6951 63.4834C83.6951 63.8365 84.0062 64.1504 84.3561 64.1504L120.866 64.5034C121.216 64.5034 121.527 64.1896 121.489 63.8365L121.372 60.5018C121.411 60.1487 121.1 59.7564 120.711 59.7564Z" fill="white"></path><path d="M120.983 67.2497L84.3949 66.8574C84.045 66.8574 83.7339 67.0535 83.7728 67.4066L83.8117 70.7413C83.8117 71.0944 84.1228 71.3298 84.4727 71.3298L121.177 71.7614C121.527 71.7614 121.838 71.526 121.8 71.1729L121.683 67.7989C121.644 67.4458 121.333 67.2497 120.983 67.2497Z" fill="white"></path><path d="M121.216 74.5468L84.4726 74.1153C84.1226 74.1153 83.8116 74.3507 83.8505 74.7038L83.8893 78.0777C83.8893 78.4308 84.2004 78.627 84.5503 78.627L121.411 79.0978C121.761 79.0978 122.072 78.9408 122.072 78.5877L121.955 75.1746C121.877 74.8215 121.566 74.5468 121.216 74.5468Z" fill="white"></path><path d="M121.449 81.9225L84.5502 81.4125C84.2002 81.4125 83.8892 81.7263 83.8892 82.0794L83.928 85.4926C83.928 85.8457 84.2391 86.1988 84.589 86.238L121.605 86.7873C121.955 86.7873 122.266 86.4342 122.227 86.0811L122.11 82.6287C122.149 82.2756 121.838 81.9225 121.449 81.9225Z" fill="white"></path></g><path d="M85.3765 1.64228C85.3765 1.18087 85.1821 0.761408 84.8711 0.425839C84.56 0.132217 84.1323 -0.0355677 83.7046 0.00637843L40.9342 3.99126C40.1566 4.07515 39.4956 4.78823 39.4956 5.62715V98.4119C39.4956 99.3347 40.2344 100.006 41.0898 100.006H85.882C86.3097 100.006 86.6985 99.88 86.9707 99.5445C87.2429 99.2089 87.4373 98.7894 87.3984 98.37L85.3765 1.64228Z" fill="#95B0DD"></path><g opacity="0.68"><path d="M47.9721 8.60532L44.706 8.81505C44.356 8.857 44.1616 9.19257 44.1616 9.61203V94.2592C44.1616 94.6787 44.2394 95.1821 44.5893 95.1821H48.011C48.3609 95.1821 48.6719 94.7626 48.6719 94.3431L48.6331 9.31841C48.6331 8.89895 48.322 8.56338 47.9721 8.60532Z" fill="#BECEEB"></path><path opacity="0.7" d="M55.9042 8.01808L52.4826 8.26976C52.1327 8.3117 51.7827 8.64727 51.7827 9.06673L51.8605 94.3431C51.8605 94.7626 52.2104 95.1821 52.5992 95.1821H56.0598C56.4097 95.1821 56.6819 94.7626 56.6819 94.3431L56.5652 8.77311C56.5263 8.35365 56.2542 8.01808 55.9042 8.01808Z" fill="#BECEEB"></path><path d="M63.9139 7.47278L60.4533 7.72446C60.1034 7.76641 59.8701 8.10198 59.8701 8.52144L60.0256 94.3431C60.0256 94.7626 60.2589 95.1821 60.6089 95.1821H64.1083C64.4971 95.1821 64.8859 94.7626 64.8859 94.3431L64.6526 8.22781C64.6915 7.80835 64.3027 7.43084 63.9139 7.47278Z" fill="#BECEEB"></path><path d="M72.0403 6.88553L68.5409 7.13721C68.1521 7.17916 67.8799 7.51473 67.8799 7.93419L68.1521 94.3431C68.1521 94.7626 68.4242 95.224 68.8131 95.224H72.3513C72.7402 95.224 73.0512 94.8045 73.0512 94.3431L72.7402 7.64056C72.779 7.2211 72.4291 6.84359 72.0403 6.88553Z" fill="#BECEEB"></path><path d="M80.2831 6.29829L76.7448 6.54997C76.356 6.59192 76.0449 6.92749 76.0449 7.38889L76.3949 94.3431C76.3949 94.7626 76.7448 95.224 77.1336 95.224H80.7108C81.0996 95.224 81.3718 94.8046 81.3718 94.3431L80.983 7.09527C80.9441 6.63386 80.6719 6.25635 80.2831 6.29829Z" fill="#BECEEB"></path></g><path d="M51.8992 19.5827C51.8992 19.1119 51.7047 18.6804 51.3937 18.3665C51.0826 18.0527 50.616 17.8958 50.1883 17.8958L16.0498 19.3081C15.4277 19.3081 15 19.8181 15 20.4066L16.7497 94.0452L51.277 93.6136C51.7047 93.6136 52.1324 93.4175 52.4435 93.1036C52.7546 92.7897 52.9101 92.3582 52.9101 91.8874L51.8992 19.5827Z" fill="#BECEEB"></path><g opacity="0.5"><path d="M24.4093 33.1178L18.9269 33.157L18.8491 23.6629H24.3704L24.4093 33.1178Z" fill="white"></path><path d="M32.3025 33.1178H26.8201L26.7812 23.6629H32.2636L32.3025 33.1178Z" fill="white"></path><path d="M40.5844 33.1178H35.1409L35.1021 23.6629H40.5455L40.5844 33.1178Z" fill="white"></path><path d="M48.8662 33.1178L43.3061 33.0786L43.1895 23.6629H48.8662V33.1178Z" fill="white"></path><path d="M24.4869 46.5744L19.0045 46.6136L18.9268 37.1979H24.448L24.4869 46.5744Z" fill="white"></path><path d="M32.3411 46.5352L26.8976 46.5744L26.8198 37.1979L32.3022 37.1587L32.3411 46.5352Z" fill="white"></path><path d="M40.623 46.4959L35.1795 46.5352L35.1406 37.1587H40.5841L40.623 46.4959Z" fill="white"></path><path d="M48.8658 46.4567L43.3057 46.4959L43.3834 37.1195H48.8658V46.4567Z" fill="white"></path><path d="M24.5647 60.3841L19.0823 60.4233L19.0435 51.0861L24.5258 51.0469L24.5647 60.3841Z" fill="white"></path><path d="M32.3798 60.3056L26.9363 60.3448L26.8975 51.0076H32.341L32.3798 60.3056Z" fill="white"></path><path d="M40.6232 60.2271L35.2186 60.2664L35.1797 50.9684L40.6232 50.9292V60.2271Z" fill="white"></path><path d="M48.866 60.1487L43.3447 60.2272L43.3836 50.9292L48.866 50.8899V60.1487Z" fill="white"></path><path d="M24.6424 73.8407L19.1989 73.9191L19.1211 64.8565L24.5646 64.8173L24.6424 73.8407Z" fill="white"></path><path d="M32.4575 73.7622L27.014 73.8014L26.9751 64.7781L32.4186 64.7388L32.4575 73.7622Z" fill="white"></path><path d="M40.6618 73.6445L35.2571 73.723L35.2183 64.6996L40.6229 64.6604L40.6618 73.6445Z" fill="white"></path><path d="M48.866 73.566L43.3447 73.6445L43.4225 64.6211L48.866 64.5819V73.566Z" fill="white"></path><path d="M24.7202 87.4542L19.2767 87.5327L19.2378 78.5485L24.6424 78.47L24.7202 87.4542Z" fill="white"></path><path d="M32.4967 87.3365L27.0921 87.415L27.0532 78.4308L32.4578 78.3523L32.4967 87.3365Z" fill="white"></path><path d="M40.6619 87.2188L35.2962 87.2973L35.2573 78.3131L40.6619 78.2739V87.2188Z" fill="white"></path><path d="M48.8662 87.1011L43.3838 87.1796L43.4227 78.2347L48.8662 78.1562V87.1011Z" fill="white"></path></g><path d="M161.433 60.9363C161.433 60.6766 160.996 60.4386 160.296 60.2655C159.597 60.0924 158.548 60.0059 157.586 60.0059L78.3604 60.7848C76.9616 60.7848 76 61.0661 76 61.3907L76.2281 102.006L157.564 101.768C158.525 101.768 159.487 101.66 160.186 101.487C160.886 101.313 161.235 101.075 161.235 100.816L161.433 60.9363Z" fill="#BECEEB"></path><g opacity="0.5"><path d="M87.9117 77.0959L81.1874 77.1928L81.0913 65.9978L87.8156 65.9494L87.9117 77.0959Z" fill="white"></path><path d="M97.5658 76.999L90.8415 77.0474L90.7935 65.9009L97.5178 65.8525L97.5658 76.999Z" fill="white"></path><path d="M107.701 76.8536L101.025 76.9505L100.977 65.804L107.653 65.7555L107.701 76.8536Z" fill="white"></path><path d="M117.835 76.7567L111.015 76.8536L111.111 65.7071L117.835 65.6586V76.7567Z" fill="white"></path><path d="M88.0082 93.9126L81.2839 94.0095L81.2358 82.9115L87.9121 82.8145L88.0082 93.9126Z" fill="white"></path><path d="M97.614 93.7672L90.9377 93.8641L90.8896 82.7661L97.5659 82.6692L97.614 93.7672Z" fill="white"></path><path d="M107.701 93.6218L101.072 93.7187L101.024 82.6207L107.701 82.5722V93.6218Z" fill="white"></path><path d="M117.835 93.4764L111.063 93.5734L111.111 82.5238L117.835 82.4268V93.4764Z" fill="white"></path></g><g opacity="0.5"><path d="M127.291 77.0959L120.566 77.1928L120.47 65.9978L127.195 65.9494L127.291 77.0959Z" fill="white"></path><path d="M136.945 76.999L130.221 77.0474L130.173 65.9009L136.897 65.8525L136.945 76.999Z" fill="white"></path><path d="M147.08 76.8536L140.403 76.9505L140.355 65.804L147.032 65.7555L147.08 76.8536Z" fill="white"></path><path d="M157.214 76.7567L150.394 76.8536L150.49 65.7071L157.214 65.6586V76.7567Z" fill="white"></path><path d="M127.387 93.9126L120.663 94.0095L120.615 82.9115L127.291 82.8145L127.387 93.9126Z" fill="white"></path><path d="M136.993 93.7672L130.317 93.8641L130.269 82.7661L136.945 82.6692L136.993 93.7672Z" fill="white"></path><path d="M147.08 93.6218L140.452 93.7187L140.404 82.6207L147.08 82.5722V93.6218Z" fill="white"></path><path d="M157.215 93.4764L150.442 93.5734L150.49 82.5238L157.215 82.4268V93.4764Z" fill="white"></path></g><path d="M53.06 89.7876C64.3822 94.5799 85.1929 106.888 109.089 98.5372C133.014 90.1869 161.305 97.4481 196.872 106.488C197.047 106.524 197.221 106.561 197.396 106.597L0 106.234C15.1642 84.85 35.6547 82.3812 53.06 89.7876Z" fill="#88B375"></path>', 11), Dt = [
  Tt
];
function Pt(e, t) {
  return V(), P("svg", jt, Dt);
}
const Ft = /* @__PURE__ */ Ve(Vt, [["render", Pt]]);
let pe;
pe = {
  de: {
    "Autosuggest.Company.NotFound": "Ihr Unternehmen ist nicht dabei? Jetzt Kontakt aufnehmen.",
    "Autosuggest.Company.NotFound1": "Ihr Unternehmen ist nicht dabei?",
    "Autosuggest.Company.NotFound2": "Bitte wenden Sie sich an Creditreform.",
    "Autosuggest.Company.Contact": "Jetzt Kontakt aufnehmen"
  },
  en: {
    "Autosuggest.Company.NotFound": "Your company is not listed? Contact us now.",
    "Autosuggest.Company.NotFound1": "Your company is not listed?",
    "Autosuggest.Company.NotFound2": "Please contact Creditreform.",
    "Autosuggest.Company.Contact": "Contact us now"
  },
  fr: {
    "Autosuggest.Company.NotFound": "Votre entreprise ne figure pas dans la liste ? Contactez-nous maintenant.",
    "Autosuggest.Company.NotFound1": "Votre entreprise ne figure pas dans la liste ?",
    "Autosuggest.Company.NotFound2": "Veuillez vous adresser à Creditreform.",
    "Autosuggest.Company.Contact": "Contactez-nous maintenant"
  }
};
const zt = (e, t, n) => {
  var r;
  let a = "";
  if (typeof e != "string" || e.length === 0)
    return a;
  if (typeof pe.de[e] == "string" && (a = pe.de[e]), typeof t == "object" && t !== null)
    if (Rt(e, t))
      typeof n == "object" && n !== "null" ? a = t.t(e, n) : a = t.t(e);
    else {
      let s = "de";
      typeof ((r = t.locale) == null ? void 0 : r.value) == "string" && t.locale.value.length && (s = t.locale.value.substring(0, 2).toLowerCase()), s in pe && typeof pe[s][e] == "string" && (a = pe[s][e]);
    }
  return a;
};
function Rt(e, t) {
  var n;
  if (typeof e != "string" || e.length === 0 || typeof t != "object" || t === null || typeof t.t != "function" || typeof t.te != "function")
    return !1;
  if (e.includes("."))
    return t.t(e) !== e;
  {
    const a = t.te(e);
    return a ? !0 : !a && (typeof ((n = t.fallbackLocale) == null ? void 0 : n.value) == "string" || t.fallbackLocale.value instanceof Array) ? t.te(e, t.fallbackLocale.value) : t.te(e, "de_DE");
  }
}
const Qt = (e) => ($e("data-v-45096cf6"), e = e(), Ne(), e), Ut = ["data-qa", "id"], Wt = { href: "https://www.creditreform.de/creditreform/kontakt" }, Gt = {
  key: 0,
  class: "not-found text-align--center pb-4 pt-2 gap-2 d-flex flex-column align-items-center"
}, Xt = { class: "text-brand-grey" }, Jt = /* @__PURE__ */ Qt(() => /* @__PURE__ */ Q("br", null, null, -1)), Yt = {
  class: "btn btn-default",
  href: "https://www.creditreform.de/creditreform/kontakt"
}, Kt = {
  __name: "crefo-autosuggest-company",
  props: {
    value: {
      type: String,
      default: null
    },
    showNoResultsBanner: {
      type: Boolean,
      default: !1
    },
    suggestions: {
      type: Function,
      required: !0
    },
    maxSuggestions: {
      type: Number,
      required: !1,
      default: 10
    },
    additionalSuggestions: {
      type: Array,
      required: !1,
      default: () => []
    },
    idInput: {
      type: String,
      required: !1,
      default: null
    },
    nameInput: {
      type: String,
      required: !1,
      default: "crefo-autosuggest-company"
    },
    classInput: {
      type: String,
      required: !1,
      default: null
    },
    placeholderInput: {
      type: String,
      required: !1,
      default: ""
    },
    crefonummerPrefix: {
      type: String,
      required: !1,
      default: "Crefonummer:"
    },
    dataQa: {
      type: String,
      required: !1,
      default: "crefo-autosuggest-company"
    },
    searchDelay: {
      type: Number,
      required: !1,
      default: 250
    },
    encodeSearchQuery: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showAjaxErrors: {
      type: Boolean,
      required: !1,
      default: !0
    },
    errorPrefix: {
      type: String,
      required: !1,
      default: "CrefoAutosuggestCompany"
    }
  },
  emits: [
    "crefo-autosuggest-company-search",
    "crefo-autosuggest-company-selected",
    "crefo-autosuggest-additional-company-selected",
    "crefo-autosuggest-company-changed",
    "crefo-autosuggest-company-suggestions-opened",
    "crefo-autosuggest-company-suggestions-closed",
    "crefo-autosuggest-company-search-success",
    "crefo-autosuggest-company-search-error"
  ],
  setup(e, { emit: t }) {
    const n = e, a = R([]), r = R(!1), s = R(null), c = R(null), i = G(() => n.value), $ = G(() => typeof this.$i18n == "object" && this.$i18n !== null && typeof this.$t == "function" && typeof this.$te == "function" ? {
      t: this.$t,
      te: this.$te,
      fallbackLocale: this.$i18n.fallbackLocale || !1,
      locale: this.$i18n.locale || "de_DE"
    } : null), f = G(() => ({
      "crefo-autosuggest-input-search": (o) => {
        const p = o.target.value;
        let m = typeof p == "string" ? p.replace(/[{\[\]}\/|`'<>%"^]/g, " ").trim() : "";
        if (m.length === 0)
          return !0;
        n.encodeSearchQuery && (m = encodeURIComponent(m));
        const q = {};
        c.value = q, typeof n.suggestions == "function" && typeof m == "string" && m.length ? l(n.suggestions, m) : (a.value = [], r.value = !1, s.value = null), t("crefo-autosuggest-company-search", m);
      },
      "crefo-autosuggest-input-item-selected": (o, p) => {
        t("crefo-autosuggest-company-selected", o, p);
      },
      "crefo-autosuggest-input-additional-item-selected": (o, p) => {
        t("crefo-autosuggest-additional-company-selected", o, p);
      },
      "crefo-autosuggest-input-item-changed": (o, p) => {
        t("crefo-autosuggest-company-changed", o, p);
      },
      "crefo-autosuggest-input-additional-item-changed": (o, p) => {
        t("crefo-autosuggest-additional-company-changed", o, p);
      },
      "crefo-autosuggest-input-suggestions-opened": () => {
        t("crefo-autosuggest-company-suggestions-opened");
      },
      "crefo-autosuggest-input-suggestions-closed": () => {
        t("crefo-autosuggest-company-suggestions-closed");
      }
    })), l = (o, p, m) => {
      r.value = !0;
      let q = !1;
      const M = /^[0-9]{10}$/.test(p), w = {
        bundesland: null,
        crefonummer: p,
        handelsName: null,
        land: null,
        name: `${n.crefonummerPrefix} ${p}`,
        ort: null,
        plz: null,
        strasseHausnummer: null
      };
      o(p).then((S) => {
        let Z = [];
        S && S.data && S.data.companyNameSuggestions && (S.data.companyNameSuggestions.forEach((B, _) => {
          M && p === B.crefonummer ? (q = !0, Z.unshift(B)) : _ < n.maxSuggestions && Z.push(B);
        }), M && !q && Z.unshift(w)), r.value = !1, c.value = null, a.value = Z, s.value = null, t("crefo-autosuggest-company-search-success", a.value);
      }).catch((S) => {
        S && S.__CANCEL__ === !0 ? (r.value = !1, c.value = null) : (r.value = !1, c.value = null, a.value = [], s.value = S, t("crefo-autosuggest-company-search-error", S));
      });
    }, u = (o) => typeof o == "object" && o !== null ? x(o) : "", x = (o) => {
      let p = "";
      return typeof o.name == "string" && o.name.length ? p = o.name : p = typeof o.crefonummer == "string" ? o.crefonummer : "", p;
    }, v = (o) => {
      let p = "", m = "";
      return typeof o.land == "string" && o.land.length && o.land !== "DE" && (p += o.land), typeof o.plz == "string" && o.plz.length && (p += p.length ? "-" : "", p += o.plz), typeof o.ort == "string" && o.ort.length && (p += p.length ? " " : "", p += o.ort), typeof o.strasseHausnummer == "string" && o.strasseHausnummer.length && (m += o.strasseHausnummer), p.length && m.length ? p += ", " + m : p += m, p;
    }, g = (o) => zt(o, $);
    return (o, p) => (V(), P("div", null, [
      ye(h(ht), Ee({
        suggestions: a.value,
        "additional-suggestions": e.additionalSuggestions,
        searching: r.value,
        "get-suggestion-value": u,
        "id-input": e.idInput,
        "name-input": e.nameInput,
        "class-input": e.classInput,
        "placeholder-input": e.placeholderInput,
        "data-qa": e.dataQa,
        "search-delay": e.searchDelay,
        value: i.value
      }, o.$attrs, qe(f.value)), {
        default: J(({ suggestion: m }) => [
          Q("div", {
            "data-qa": `autosuggest__results-item--${m == null ? void 0 : m.crefonummer}`,
            id: `autosuggest__results-item--${m == null ? void 0 : m.crefonummer}`
          }, [
            Q("div", null, U(x(m)), 1),
            Q("div", null, U(v(m)), 1)
          ], 8, Ut)
        ]),
        "additional-suggestions": J((m) => [
          D(o.$slots, "additional-suggestions", { suggestion: m }, () => [
            le(U(m.suggestion), 1)
          ], !0)
        ]),
        "after-suggestions": J(() => [
          Q("li", {
            onMouseup: p[0] || (p[0] = Ge(() => {
            }, ["stop"])),
            class: "text-bold text-align--center",
            style: { "border-top": "1px solid #009ee2" }
          }, [
            Q("a", Wt, U(g("Autosuggest.Company.NotFound")), 1)
          ], 32),
          D(o.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 16, ["suggestions", "additional-suggestions", "searching", "id-input", "name-input", "class-input", "placeholder-input", "data-qa", "search-delay", "value"]),
      e.showNoResultsBanner ? (V(), P("div", Gt, [
        ye(Ft),
        Q("div", Xt, [
          Q("p", null, [
            le(U(g("Autosuggest.Company.NotFound1")), 1),
            Jt,
            le(" " + U(g("Autosuggest.Company.NotFound2")), 1)
          ])
        ]),
        Q("a", Yt, U(g("Autosuggest.Company.Contact")), 1)
      ])) : re("", !0),
      s.value && e.showAjaxErrors ? (V(), Se(h(Ae), {
        key: 1,
        "ajax-error": s.value,
        "error-prefix": e.errorPrefix,
        class: "mt"
      }, null, 8, ["ajax-error", "error-prefix"])) : re("", !0)
    ]));
  }
}, tn = /* @__PURE__ */ Ve(Kt, [["__scopeId", "data-v-45096cf6"]]);
export {
  tn as default
};
